export class DopSessionRevocationConfig {
    serviceBaseUrl: string;
    sessionCheckInterval: number;
}